export function formatGraphNumericalValue(
  value: number,
  decimalPlaces: number,
  currencyCode: string,
  unit: string,
): string {
  if (currencyCode) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(
      value,
    );
  } else {
    return `${new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(value)} ${unit}`;
  }
}
